/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Configuration_Plan_InstructionsInputs */

const fr_heating_network_configuration_plan_instructions = /** @type {((inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Sélectionner plusieurs pièces/têtes th. :
 + sélectionner une zone`)
		}),
		{
			parts: /** @type {(inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Sélectionner plusieurs pièces/têtes th. :\n" }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + sélectionner une zone" }])
			})
		}
	)
);

const en_heating_network_configuration_plan_instructions = /** @type {((inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => LocalizedString) & { parts: (inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Select multiple rooms/th. heads:
 + select an area`)
		}),
		{
			parts: /** @type {(inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Select multiple rooms/th. heads:\n" }, { type: "markup-start", name: "i", options: {}, attributes: {} }, { type: "markup-end", name: "i", options: {}, attributes: {} }, { type: "text", value: " + select an area" }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Select multiple rooms/th. heads: + select an area" |
*
* @param {Heating_Network_Configuration_Plan_InstructionsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_configuration_plan_instructions = /** @type {((inputs?: Heating_Network_Configuration_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Heating_Network_Configuration_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Heating_Network_Configuration_Plan_InstructionsInputs, { locale?: "fr" | "en" }, { i: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Heating_Network_Configuration_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_heating_network_configuration_plan_instructions(inputs)
			return fr_heating_network_configuration_plan_instructions(inputs)
		}),
		{
			parts: /** @type {(inputs?: Heating_Network_Configuration_Plan_InstructionsInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (en_heating_network_configuration_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: en_heating_network_configuration_plan_instructions(inputs) }]
				return /** @type {{ parts?: (inputs: Heating_Network_Configuration_Plan_InstructionsInputs) => import('../runtime.js').MessagePart[] }} */ (fr_heating_network_configuration_plan_instructions).parts?.(inputs) ?? [{ type: "text", value: fr_heating_network_configuration_plan_instructions(inputs) }]
			})
		}
	)
);